export default __webpack_public_path__ + "static/media/addedcart-icon.52e040f7.svg";